<ng-container *transloco="let t">
  <form id="inputForm" [formGroup]="inputForm" (ngSubmit)="submit(inputForm)">
    <div class="row text-center justify-content-center mt-3">
      <div class="col-12 col-sm-5 col-md-3 col-lg-2">
        <mat-form-field class="w-100" appearance="fill">
          <mat-label for="groupId">{{t('select-work-unit-session.groupId')}}</mat-label>
          <mat-select formControlName="groupId">
            <mat-option *ngFor="let g of groups$ | async" [value]="g.id">{{g.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 col-sm-7 col-md-6 col-lg-4">
        <mat-form-field class="w-100" appearance="fill">
          <mat-label for="workUnitId">{{t('select-work-unit-session.workUnitId')}}</mat-label>
          <mat-select formControlName="workUnitId">
            <mat-option *ngFor="let wu of workUnits$ | async" [value]="wu.id">{{wu.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </form>
</ng-container>
